import React,{useEffect} from 'react';


import comfort1 from '../../images/comfort room/comfort1.jpg';
import { Button, Carousel, Col, Container, Form, FormControl, FormGroup, FormLabel, NavLink, Row } from 'react-bootstrap';

import ComfortVid from '../../videos/ComfortVideo01.mp4';
import {IoIosArrowBack} from 'react-icons/io';
import comfort11 from '../../images/comfort room converted/comfort1.jpg';
import comfort2 from '../../images/comfort room converted/comfort2.jpg';
import comfort3 from '../../images/comfort room converted/comfort3.jpg';
import comfort4 from '../../images/comfort room converted/comfort4.jpg'
import { HashLink as Link } from 'react-router-hash-link';
import Aos from "aos";
import "aos/dist/aos.css";

import './DeluxRoom.css';

function DeluxRoomPage() {
    useEffect(() => {
        window.scroll(0,0)
        Aos.init({duration:2000});
      }, []);


    return (
        <div>
             <section  className='HeaderPageWrapper'>
                {/* <img src={comfort1} alt='tof' className='luxRoom' /> */}
                <a href='https://www.youtube.com/watch?v=yZgnX-i0gN8'>
                    <video className='videoTag' autoPlay loop muted >
                        <source src={ComfortVid} type='video/mp4' />
                    </video>
                </a>
                <div className='headerWrapper'>
                    <h1>COMFORT DOUBLE ROOMS </h1>
                </div> 
            </section>
        <section className='DiscoverBody'>  
            <section id='lux' className='MovingCard1'>
            <div className='PrevBox'>
                <Link to='/discover/#comfort' className='Previous' ><IoIosArrowBack />  Rooms /</Link>
                <Link className='present' to=''>Confort Double</Link>
            </div>
            <div className='room-list-wrapper'>
              
                  <Container data-Aos='fade-in'  className='image-wrapper'>
                        {/* <video className='imageTag' controls  muted >
                            <source src={Video} type='video/mp4' />
                        </video> */}
                        <Carousel interval={null} fade='true'  >
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                              src = {comfort11}
                              alt = "" />
                          {/* <Carousel.Caption>
                            <h3>First slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {comfort2}
                            alt = "" />
                            {/* <Carousel.Caption>
                            <h3>Second slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {comfort3}
                            alt = "" />
                          {/* <Carousel.Caption>
                            <h3>Third slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {comfort4}
                            alt = "" />
                          
                          </Carousel.Item>
                    </Carousel> 
                      
                  </Container>
              
              
                  <div data-Aos='fade-in' className='features-wrapper1'>
                      <div className='content-header'>
                        <h3 className='executive-header'>COMFORT DOUBLE</h3>
                        {/* <p>4 well appointed Comfort King Size Rooms...</p> */}
                      </div>
                      
                      <div>
                          <p>
                          In our beautiful and spacious Comfort Double Room, you will not 
                          only relax in comfort but also enjoy all the amenities you need 
                          for a carefree and relaxing stay along the swift service from our 
                          Hotel staff. Here are room facilities:
                          </p>
                      </div>
                      <div style={{display:'flex',justifyContent:'space-between'}}>
                          <ul>
                            <li>Air Conditioning</li>
                            <li>King Size Bed</li>
                            <li>Premium Linen & Bedding</li>
                            <li>Android TV with Netflix, Amazon Prime, etc.</li>
                            <li>Direct Dial Telephone</li>
                            <li>Bathroom with Shower</li>
                            <li>Razor Plug</li>
                            <li>Hair Dryer on-demand (Free of charge)</li>
                            <li>Laundry Services (Fees are applied)</li>
                            <li>Extra Rollaway Bed (Chargeable)</li>
                            <li>24 Hrs Room Service</li>
                            

                          </ul>
                          <ul>
                            <li>Wake-Up Call</li>
                            <li>Office Table/Chair</li>
                            <li>Wi-Fi Internet Access Free of Charge</li>
                            <li>Bath Amenities – Herbal Soap & Shampoo</li>
                            <li>24 Hrs Hot Water</li>
                            <li>Closet with Lock</li>
                            <li>Daily Housekeeping</li>
                            <li>Modern Furnishing</li>
                            <li>Deep Room Sanitization</li>
                            <li>Complementary Water Bottles</li>
                            <li>Modern Furnishing</li>
                            
                          </ul>
                          </div>

                      <div className='bookNowClassic'>
                      <a href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/Cb-5qoivag2KMclH4qeG5Q/#/search'>
                            <Button className='bookNowlink'style={{color:'#4d3319'}} to=''>BOOK NOW</Button>
                          </a>
                      </div>
                  </div>
              
              

            </div>
          
        </section>
        </section>
        </div>
    )
}

export default DeluxRoomPage

